import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap"
import TableContainer from "components/Common/TableContainer"

const StockGroupAccordion = ({
  groupsData,
  openAccordionItems,
  toggleAccordion,
  groupPages,
  renderGroupPagination,
  getPaginatedGroupData,
  columnsProps,
}) => {
  return (
    <Accordion open={openAccordionItems} toggle={toggleAccordion}>
      {Object.entries(groupsData).map(([groupName, vehicles]) => {
        const paginatedVehicles = getPaginatedGroupData(groupName, vehicles)
        const currentPage = groupPages[groupName] || 1

        return (
          <AccordionItem key={groupName}>
            <AccordionHeader targetId={groupName}>
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <strong>{groupName}</strong>
                  <span className="badge badge-soft-primary ms-2">{vehicles.length} vehicles</span>
                </div>
                {vehicles.length > 20 && (
                  <span className="badge badge-soft-warning me-2">
                    Page {currentPage} of {Math.ceil(vehicles.length / 20)}
                  </span>
                )}
              </div>
            </AccordionHeader>
            <AccordionBody accordionId={groupName}>
              <TableContainer
                columns={columnsProps}
                data={paginatedVehicles}
                isPagination={false}
              />
              {renderGroupPagination(groupName, vehicles)}
            </AccordionBody>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default StockGroupAccordion
